import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ACCOUNT_MENU_GROUPS, ACCOUNT_DELETE_PATH } from '../../data/accountMenu';

export function AccountDropdownMenu({ onClose, onLogout, className }) {
  return (
    <div className={className} role="menu">
      {ACCOUNT_MENU_GROUPS.map((group) => (
        <div key={group.label} className="account-dropdown__group">
          <div className="account-dropdown__label" role="presentation">
            {group.label}
          </div>
          {group.items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `account-dropdown__link${isActive ? ' account-dropdown__link--active' : ''}`
              }
              role="menuitem"
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      ))}
      <div className="account-dropdown__separator" role="separator" />
      <Link
        to={ACCOUNT_DELETE_PATH}
        className="account-dropdown__link account-dropdown__link--danger"
        role="menuitem"
        onClick={onClose}
      >
        Delete account
      </Link>
      <button
        type="button"
        className="account-dropdown__btn"
        role="menuitem"
        onClick={() => {
          onClose();
          onLogout();
        }}
      >
        Logout
      </button>
    </div>
  );
}
